import { Alert, Box, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import CustomNumberField from "../../utils/CustomNumberField";
import { useText } from "../../main.tsx";
import { createLogger } from "../../lib/logger.ts";

const logger = createLogger("SolarModuleAmountChooser");


type Props = {
    currentModuleCount: number;
    onModuleCountChange: (newCount: number) => void;
    maxModuleCount: number;
};

type SolarModuleConfig = {
    current: number
    minCount: number,
    maxCount: number,
}

const SolarModuleAmountChooser: React.FC<Props> = ({
    currentModuleCount,
    onModuleCountChange,
    maxModuleCount
}) => {
    const [moduleCount, setModuleCount] = useState<SolarModuleConfig>({
        current: currentModuleCount,
        minCount: 8,
        maxCount: maxModuleCount,
    });

    const { t } = useText();

    const handleModuleCountChange = (current: number) => {
        setModuleCount((prev) => ({
            ...prev,
            current: current
        }));

        onModuleCountChange(current);
    };

    useEffect(() => {
        logger.debug('Infinity', { currentModuleCount });
        setModuleCount({ ...moduleCount, current: currentModuleCount });
    }, [currentModuleCount]);

    return (
        <Box>
            <Typography variant="h2">
                {t('funnel.wizard.moduleSelection.title')}
            </Typography>
            <Typography>
                {t('funnel.wizard.moduleSelection.description')}
            </Typography>
            {moduleCount.current > maxModuleCount && (
                <Alert severity={"error"}>
                    <span dangerouslySetInnerHTML={{ __html: t('funnel.wizard.moduleSelection.error')! }}/>
                </Alert>
            )}
            <Paper
                sx={{
                    borderRadius: 2,
                    border: "1px solid #cccccc",
                    backgroundColor: "rgba(255,255,255,0.6)",
                    backdropFilter: "blur(15px)",
                    width: 168,
                }}
            >
                <CustomNumberField
                    defaultValue={moduleCount.current <= maxModuleCount ? moduleCount.current : maxModuleCount}
                    min={moduleCount.minCount}
                    max={maxModuleCount}
                    onChange={handleModuleCountChange}
                />
            </Paper>

        </Box>
    );
};

export default SolarModuleAmountChooser;
